import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
// import index from './views/index/index.vue'
// import modifyOrder from './views/modifyOrder/modifyOrder.vue'
// import orderList from './views/order/orderList.vue'
// import needPayInfo from './views/pay/needPayInfo.vue'
// import miaosha from './views/miaosha.vue'
// import miaoshaView from './views/miaosha/miaoshaView.vue'
// import activeBusinessUserInfo from './views/activeBusiness/userInfo/activeBusinessUserInfo.vue'
import activityBusinessNeedToPay from './views/activeBusiness/pay/activityBusinessNeedToPay.vue'
// import activityBusinessIndex from './views/activeBusiness/activityBusinessIndex.vue'
import activeBusinessPaySuccess from './views/activeBusiness/pay/success.vue'
import businessCheckPayResult from './views/activeBusiness/pay/checkPayResult.vue'
import zaiJiaTryInfo from './views/zaijiakankan/zaiJiaTryIndex'
import zaiJiaUserInfo from './views/zaijiakankan/userInfo/zaiJiaUserInfo'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: 'all',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      children:[
    //    {path: '/index', name:'index', component: index},
    //    {path: '/modifyOrder/:od', name:'modifyOrder', component: modifyOrder},
    //    {path: '/orderList', name:'orderList', component: orderList},
    //    {path: '/needPayInfo', name:'needPayInfo', component: needPayInfo},
    //    {path: '/miaosha', name:'miaosha', component: miaosha},
    //    {path: '/miaoshaView', name:'miaoshaView', component: miaoshaView},
        // {path: '/activeBusinessUserInfo', name:'activeBusinessUserInfo', component: activeBusinessUserInfo},
        {path: '/abnp', name:'activityBusinessNeedToPay', component: activityBusinessNeedToPay},
        // {path: '/activityBusinessIndex', name:'activityBusinessIndex', component: activityBusinessIndex},
        {path: '/businessCheckPayResult', name:'businessCheckPayResult', component: businessCheckPayResult},        
        {path: '/activeBusinessPaySuccess', name:'activeBusinessPaySuccess', component: activeBusinessPaySuccess},
          {path: '/zaiJiaTryInfo',name: 'zaiJiaTryInfo',component: zaiJiaTryInfo},
          {path: '/zaiJiaUserInfo',name: 'zaiJiaUserInfo',component: zaiJiaUserInfo}
      ]
    }
  ]
})
